import { render, staticRenderFns } from "./ActiveFilterChip.vue?vue&type=template&id=755373a6&scoped=true&"
import script from "./ActiveFilterChip.vue?vue&type=script&lang=js&"
export * from "./ActiveFilterChip.vue?vue&type=script&lang=js&"
import style0 from "./ActiveFilterChip.vue?vue&type=style&index=0&id=755373a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755373a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
